// ✅ Global document bounds storage (module-level)
let globalDocumentBounds = [];

// ✅ Global snap targets storage (module-level)
let globalSnapTargets = null;

// ✅ Global snap mode storage (module-level)
let globalSnapMode = false;

// ✅ Global enabled snap types storage (module-level)
let globalEnabledSnapTypes = null;

/**
 * Global document bounds'u günceller.
 * @param {Array} bounds - Doküman sınırları dizisi
 */
export function setGlobalDocumentBounds(bounds) {
  globalDocumentBounds = bounds || [];
}

/**
 * Global document bounds'u döndürür.
 * @returns {Array} - Doküman sınırları dizisi
 */
export function getGlobalDocumentBounds() {
  return globalDocumentBounds;
}

/**
 * Global snap targets'ı günceller.
 * @param {Object|null} targets - Snap hedefleri {mimariCizim, kullaniciCizim, tesisatCizim, dokumanlar}
 */
export function setGlobalSnapTargets(targets) {
  globalSnapTargets = targets || null;
}

/**
 * Global snap targets'ı döndürür.
 * @returns {Object|null} - Snap hedefleri
 */
export function getGlobalSnapTargets() {
  return globalSnapTargets;
}

export function setGlobalSnapMode(mode) {
  globalSnapMode = mode;
}

export function getGlobalSnapMode() {
  return globalSnapMode;
}

export function setGlobalEnabledSnapTypes(types) {
  globalEnabledSnapTypes = types || null;
}

export function getGlobalEnabledSnapTypes() {
  return globalEnabledSnapTypes;
}

// ✅ Global line segments storage (for dynamic nearest/perpendicular snaps)
let globalLineSegments = [];

export function setGlobalLineSegments(segs) {
  globalLineSegments = segs || [];
}

export function getGlobalLineSegments() {
  return globalLineSegments;
}

/**
 * Mouse'un hangi kat planı dokümanı içinde olduğunu tespit eder.
 *
 * @param {THREE.Vector3} worldPoint - Mouse'un dünya koordinatlarındaki pozisyonu
 * @param {Array} documentBounds - Doküman sınırları dizisi [{floorPlanId, minX, maxX, minY, maxY}, ...] (opsiyonel, yoksa global kullanılır)
 * @returns {string|null} - Aktif kat planı ID'si veya null
 */
export function getActiveFloorPlanId(worldPoint, documentBounds = null) {
  const boundsArray = documentBounds || globalDocumentBounds;
  if (!worldPoint || !boundsArray || boundsArray.length === 0) {
    return null;
  }

  const x = worldPoint.x;
  const y = worldPoint.y;

  // ✅ FIX: "bounds" yerine "boundsArray" kullanıyoruz (variable shadowing bug düzeltildi)
  for (const bound of boundsArray) {
    if (!bound.floorPlanId) continue; // Sadece kat planı dokümanlarını kontrol et

    if (x >= bound.minX && x <= bound.maxX && y >= bound.minY && y <= bound.maxY) {
      return bound.floorPlanId;
    }
  }

  return null;
}

/**
 * Snap noktalarını aktif kat planına göre filtreler.
 *
 * @param {Array} snapPoints - Tüm snap noktaları
 * @param {string|null} activeFloorPlanId - Aktif kat planı ID'si
 * @returns {Array} - Filtrelenmiş snap noktaları
 */
export function filterSnapPointsByFloorPlan(snapPoints, activeFloorPlanId) {
  if (!activeFloorPlanId) {
    // Aktif kat planı yoksa tüm snap noktalarını döndür
    return snapPoints;
  }

  return snapPoints.filter(sp => {
    // floorPlanId'si olmayan noktalar (wire'lar, panel'ler vb.) her zaman dahil
    if (!sp.floorPlanId) return true;
    // Sadece aktif kat planının snap noktalarını dahil et
    return sp.floorPlanId === activeFloorPlanId;
  });
}
